import moment from "moment";
import { DateFormat } from "../data/constants";

const birthdateOffset = 30;
const humanAgeOffset = 100;

export const getBirthdateDefaultValue = () => {
  const defaultDate = new Date();
  defaultDate.setFullYear(defaultDate.getFullYear() - birthdateOffset);
  return defaultDate;
};

export const getMinimumValidDate = () => {
  const minimumDate = new Date();
  minimumDate.setFullYear(minimumDate.getFullYear() - humanAgeOffset);
  return minimumDate;
};

export const areDatesEqual = (date1: Date, date2: Date) => {
  const firstDate = new Date(date1);
  firstDate.setHours(0, 0, 0, 0);

  const secondDate = new Date(date2);
  secondDate.setHours(0, 0, 0, 0);

  return firstDate.getTime() === secondDate.getTime();
};

export const isDateInArray = (date: Date, datesArray: Date[]) => {
  for (var i = 0; i < datesArray.length; i++) {
    if (date.getTime() === datesArray[i].getTime()) {
      return true;
    }
  }
  return false;
};

export const getValidDate = (date: Date) => {
  if (new Date(date).getTime() < getMinimumValidDate().getTime()) {
    return null;
  }

  return date;
};

export const getDateFromString = (dateString: string) => moment(dateString).format(DateFormat);
